import { required } from "vuelidate/lib/validators";
import AIModelService from "../../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../../helpers/general";
import { ERRORS_CODE } from "../../../../const/error_code";
import { ACTIVATE_FUNCS } from "../../../../const/activate_func";
import { LAYER_TYPE } from "../../../../const/aimodel";

export default {
    components: {
    },
    data() {
        return {
            isCreate: true,
            formSubmitted: false,
            errors: {},
            page_title: '',
            activate_funcs: ACTIVATE_FUNCS,
            LAYER_TYPE: LAYER_TYPE,
            aiModelLayer: {
                model_id: null,
                layer_no: null,
                type: LAYER_TYPE.hidden,
                in_features: 0,
                out_features: 0,
                activate_func: '',
                normalize_enable: 0,
                dropout: 0.0,
                disp_order: 0,
            }
        }
    },
    methods: {
        handleForm() {
            this.errors = {};
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                if (this.isCreate) {
                    return this.createAIModelLayer();
                } else {
                    return this.updateAIModelLayer();
                }
            }
        },
        createAIModelLayer() {
            AIModelService.createAIModelLayer(this.aiModelLayer).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.create_success"));
                    this.$router.push({name: 'aimodel-layer', params: { id: this.aiModelLayer.model_id}});
                    //this.aiModel.id = response.data.data.id;
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION) {
                    alertResponseError(this.$t("message_error.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(error.response.data.msg);
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME) {
                    alertResponseError(this.$t("message_error.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                } else {
                    alertResponseError(error);
                }
            }); 
        },
        getAIModelLayerWithAiModelIdAndLayerNo(aiModelLayer) {
            AIModelService.getAIModelLayerWithAiModelIdAndLayerNo(aiModelLayer).then((response) => {
                this.aiModelLayer = response.data.data;
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                }
                else if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_LAYER_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_layer_detail.ai_model_layer_not_found"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        updateAIModelLayer() {
            return AIModelService.updateAIModelLayer(this.aiModelLayer).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.update_success"));
                    this.$router.push({name: 'aimodel-layer', params: { id: this.aiModelLayer.model_id}});
                }
            }).catch((error) => {
                if(error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(this.$t("message_error.CAN_NOT_CREATE_OR_EDIT_AI_MODEL"));
                }  else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                }else {
                    return alertResponseError(error);
                }
                
            });
        },
    },
    created() {
        document.title = this.page_title 
        this.page_title = this.$t(`${this.$route.meta.title}.title_page`);
        
        // set aiModelId and layerNo
        this.aiModelLayer.model_id = this.$route.params.model_id;
        this.aiModelLayer.layer_no = this.$route.params.layer_no !== undefined ? this.$route.params.layer_no : null;
        this.aiModelLayer.type = this.LAYER_TYPE.hidden;

        // check is create or update
        this.isCreate = this.aiModelLayer.layer_no !== null ? false : true;
        if (!this.isCreate) {
            this.getAIModelLayerWithAiModelIdAndLayerNo(this.aiModelLayer);
        }
    },
    computed: {
        /*
        inFeaturesError() {
            if (!this.$v.aiModelLayer.in_features.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model_layer.in_features") });
            }
            return null;
        },
        */
        outFeaturesError() {
            if (!this.$v.aiModelLayer.out_features.required || !this.$v.aiModelLayer.out_features.isPositive) {
                return this.$t("common_errors.required", { field: this.$t("ai_model_layer.out_features") });
            }
            return null;
        },
        activateFuncError() {
            return null;
        },
        normalizeEnableError() {
            return null;
        },
        dropoutError() {
            return null;
        }
    },
    validations() {
        return {
            aiModelLayer: {
                //in_features: { required },
                out_features: { 
                    required,
                    isPositive(value) {
                        return value > 0;
                    }
                },
            }
        }
    }
}